import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "qtl-min__label" }
const _hoisted_2 = { class: "qtl-min__body" }

import { ref } from "vue";
import { i18n } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'MinimizedCellLite',
  props: {
    minimized: { type: Boolean },
    count: {}
  },
  setup(__props: any) {



const t = (k: string) => i18n.global.t(k);
const open = ref(false);

return (_ctx: any,_cache: any) => {
  return (_ctx.minimized)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("button", {
          type: "button",
          class: "qtl-min__toggle",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value = !open.value), ["stop"]))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["qtl-min__chevron", { 'qtl-min__chevron--open': open.value }])
          }, "▾", 2),
          _createElementVNode("span", _hoisted_1, _toDisplayString(t('items')) + ": " + _toDisplayString(_ctx.count), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, open.value]
        ])
      ], 64))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})